import { render } from "./sports.vue?vue&type=template&id=9d1c0870"
import script from "./sports.vue?vue&type=script&lang=js"
export * from "./sports.vue?vue&type=script&lang=js"

import "./sports.vue?vue&type=style&index=0&id=9d1c0870&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__